import { intl } from 'modules/i18n';

const integerNumberRegExp = new RegExp('^(0|-?[1-9]\\d*)$', 'i');

export const validateIntegerValue = (value) =>
    value && !integerNumberRegExp.test(value) ?
        intl.formatMessage({ id: 'validationErrors.custom.IntegerField' }) :
        undefined;
